<template>
  <div>
    <b-row class="mb-3">
      <b-col>
        <label>Filter Level</label>
        <br />
        <b-form-select v-model="filteredLevel" :options="levelOption" @change="changeClass()"></b-form-select>
      </b-col>
      <b-col>
        <label>Filter Class</label>
        <br />
        <b-form-select v-model="filteredClass" :options="classOption" @change="classroomList()"></b-form-select>
      </b-col>
    </b-row>

    <div class="space-between align-center">
      <div class="align-center flex-1">
        <div class="filter-icon">
          <img src="/img/filter.svg" alt="" />
        </div>

        <div class="search-wrappper">
          <b-input-group size="sm">
            <b-form-input v-model="filter" placeholder="Search here...">
            </b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>

      <button
        type="button"
        class="btn mulai btn-secondary font-bold"
        @click="handleNew"
      >
        <fa-icon icon="edit" class="my-icon" />&nbsp; ADD NEW CLASSROOM
      </button>
    </div>
    <br />
    <br />
    <!-- Main table element -->
    <b-table
      show-empty
      stacked="md"
      :busy="isBusy"
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
    >
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template #cell(status)="row">
        <b-badge variant="success" v-if="row.item.status">Publish</b-badge>
        <b-badge variant="secondary" v-else>Unpublish</b-badge>
      </template>

      <template #cell(actions)="row">
        <b-button
          size="sm"
          class="mr-3 mb-2 action-button"
          variant="outline-secondary"
          @click="handleEdit(row.item)"
        >
          <fa-icon icon="pencil-alt" />&nbsp;Edit
        </b-button>

        <b-button
          size="sm"
          class="mr-3 mb-2 action-button"
          variant="outline-warning"
          @click="handlePublish(row.item)" 
          v-if="row.item.status"
        >
          <fa-icon icon="minus-circle" class="my-icon" />&nbsp;Unpublish
        </b-button>
        <b-button
          size="sm"
          class="mr-3 mb-2 action-button"
          variant="outline-success"
          @click="handlePublish(row.item)" 
          v-else
        >
          <fa-icon icon="plus-circle" class="my-icon" />&nbsp;Publish
        </b-button>
      </template>
    </b-table>

    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>

    <b-modal
      v-model="addModal"
      id="addModal"
      hide-header
      hide-footer
      centered
    >
      <modal-cross @close="addModal = false"></modal-cross>
      <div class="p-4">
        <h3 class="txt-center color2">Create New Classroom</h3>
        <br />

        <label>Level</label>
        <br />
        <b-form-select v-model="inputData.level" :options="levelOption" @change="changeClassForm()"></b-form-select>
        <br><br>

        <label>Class</label>
        <br />
        <b-form-select v-model="inputData.class" :options="classOptionForm"></b-form-select>
        <br><br>

        <label>Name</label>
        <br />
        <b-form-input
          v-model="inputData.name"
          placeholder="Enter name..."
        ></b-form-input>
        <br />

        <div class="justify-end">
          <my-button
            type="blue"
            disabled
            v-show="showLoading"
          >
            <b-spinner small></b-spinner>
            <span class="sr-only">Loading...</span>
          </my-button>
          <my-button
            type="blue"
            v-show="!showLoading"
            @click="handleSave"
          >
            SAVE
          </my-button>
        </div>
        <br />
      </div>
    </b-modal>

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  data() {
    return {
      levelOption:[{value: '', text: "All"}],
      classOption:[{value: '', text: "All"}],
      classOptionForm:[{value: '', text: "All"}],
      filteredLevel: '', 
      filteredClass: '', 
      items: [],
      fields: [
        {
          key: "id",
          label: "#ID", 
          sortable: true,
          sortDirection: "asc"
        },
        {
          key: "name",
          label: "Subject Name",
          sortable: true
        },
        {
          key: "class",
          label: "Class",
          sortable: true
        },
        {
          key: "level",
          label: "Level",
          sortable: true
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "actions",
          label: "Action"
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      isBusy: false,
      editData: false,
      addModal: false,
      inputData: {
        id: 0,
        name: "",
        level: "", 
        class: ''
      },
      showLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn"
    })
  },
  created() {
    if (!this.isLoggedIn) {
      this.$router.push("/login");
    }
  },

  mounted() {
    this.totalRows = this.items.length;
    this.classroomList();
    this.levelList();
  },

  methods: {
    ...mapActions({
      getLevelList: types.GET_LEVEL_LIST,
      getClassList: types.GET_CLASS_LIST,
      getClassroomList: types.CLASSROOM_LIST,
      classroomCreate: types.CLASSROOM_CREATE, 
      classroomUpdate: types.CLASSROOM_UPDATE
    }),
    levelList() {
      this.getLevelList()
      .then(response => {
        this.levelOption = [{value: '', text: "All"}];
        for (var i = 0; i < response.length; i++) {
          this.levelOption.push({
            value: response[i].id, 
            text: response[i].name
          });
        }
      })
      .catch(error => {
        this.showMessageBox(error, "Failed", "success");
      });
    },
    changeClass() {
      this.classroomList()

      this.classOption = [{value: '', text: "All"}];
      this.filteredClass = ''

      if(this.filteredLevel) {
        this.classList()
      }
    },
    changeClassForm() {
      this.classOptionForm = [{value: '', text: "All"}];
      this.inputData.class = ''

      if(this.inputData.level) {
        this.classList(true)
      }
    },
    classList(form = false) { 
      var payload = {
        params: {
          order: 'code'
        }
      }

      if(form) {
        payload.params.level = this.inputData.level
      } else {
        payload.params.level = this.filteredLevel
      }

      this.getClassList(payload)
      .then(response => {
        for (var i = 0; i < response.length; i++) {
          if(form) {
            this.classOptionForm.push({
              value: response[i].id, 
              text: response[i].name + (response[i].major ? (" " + response[i].major) : "")
            });
          } else {
            this.classOption.push({
              value: response[i].id, 
              text: response[i].name + (response[i].major ? (" " + response[i].major) : "")
            });
          }
        }
      })
      .catch(error => {
        this.showMessageBox(error, "Failed", "success");
      });
    },
    classroomList() {
      var payload = {
        params: {}
      }

      if(this.filteredLevel) {
        payload.params.level = this.filteredLevel
      }

      if(this.filteredClass) {
        payload.params.class = this.filteredClass
      }

      this.isBusy = true;
      this.getClassroomList(payload)
        .then(response => {
          this.items = response;
          this.totalRows = response.length;
          this.isBusy = false;
        })
        .catch(error => {
          this.showMessageBox(error, "Failed", "success");
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    handleEdit(item) {
      this.$router.push('/classroom/edit/' + item.id)
    },
    handleNew() {
      this.addModal = true;
    },
    handleSave() {
      if(this.inputData.name && this.inputData.class) {
        this.addClassroom();
      } else {
        this.showMessageBox('Please input all data', 'Empty Data', 'danger')
      }
    },
    handlePublish(item) {
      var flag = item.status ? 0 : 1
      var text = item.status ? 'Unpublish' : 'Publish'

      this.$bvModal.msgBoxConfirm( text + ' this data?', {
        title: 'Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value) {
          this.classroomUpdate({id:item.id, status: flag})
          .then(response => {
            this.classroomList();
            this.showMessageBox(text+"ed", "Success", "success");
          })
          .catch(error => {
            this.showMessageBox(error, "Failed", "success");
          });
        }
      })
      .catch(err => {
        this.showMessageBox(err, "Failed", "success");
      });
    },
    addClassroom() {
      this.showLoading = true;

      var payload = {
        name: this.inputData.name, 
        class_id: this.inputData.class
      }

      this.classroomCreate(payload)
      .then(response => {
        // eslint-disable-next-line
        var res = response;
        this.addModal = false;
        this.showLoading = false;
        this.classroomList();
      })
      .catch(error => {
        this.showLoading = false;
        this.showMessageBox(error, "Failed", "success");
      });
    },
    showMessageBox(message, title, variant) {
      this.$bvModal
      .msgBoxOk(message, {
        title: title,
        size: "sm",
        buttonSize: "sm",
        okVariant: variant,
        centered: true
      })
      .then(value => {
      })
      .catch(err => {
      });
    }
  }
};
</script>

<style>
.filter-icon {
  margin-right: 11px;
  background-color: #e9e9e9;
  width: 32px;
  height: 32px;
  border-radius: 32px;
  text-align: center;
  padding-top: 7px;
}

.action-button:hover {
  background-color: #f08045;
  border: 1px solid #f08045;
}
</style>